import { EntityType } from '@qover-private/protos-web/qover/dojo/contracts/v1/policyholder';
import { Risk as RiskProtos } from '@qover-private/protos-web/qover/dojo/travel/v1/risk';
import { PolicyholderProps } from '@qover/domain';
import { Relation, Person, RiskProps } from '../Risk';

const getPersonForPolicyholder = (person?: Person) => ({
  firstName: person?.firstName,
  lastName: person?.lastName,
  birthdate: person?.birthdate,
  title: person?.title,
});

export function mapFromApiResponse(
  response?: RiskProtos,
  policyholder?: PolicyholderProps,
): RiskProps {
  const persons = response?.persons ?? [{ relation: Relation.RELATION_ADULT }];

  const adultsList: Array<Person> = [];
  const childrenList: Array<Person> = [];

  persons.forEach(p => {
    if (p.relation === Relation.RELATION_ADULT) {
      adultsList.push(p);
    } else if (p.relation === Relation.RELATION_CHILD) {
      childrenList.push(p);
    }
  });

  const hasDefaultPolicyholder =
    policyholder?.entityType !== EntityType.ENTITY_TYPE_PERSON ||
    policyholder?.birthdate;

  const policyholderToCompare = hasDefaultPolicyholder
    ? policyholder
    : adultsList[0];

  const insuredPerson = adultsList?.find(
    person =>
      person.birthdate === policyholderToCompare?.birthdate &&
      person.firstName === policyholderToCompare?.firstName &&
      person.lastName === policyholderToCompare?.lastName,
  );

  let insuredPersonId;

  // If an insured person is equal to the policyholder
  if (
    insuredPerson &&
    policyholder?.entityType === EntityType.ENTITY_TYPE_PERSON
  ) {
    insuredPersonId = JSON.stringify(getPersonForPolicyholder(insuredPerson));
  }

  return {
    adultsList,
    childrenList,
    insuredPersonId,
  };
}
